import React from 'react';
import { Alert } from '../../../../../../base/components/Alert';
import { Button } from '../../../../../../base/components/Button';
import { Input } from '../../../../../../base/components/Forms/Input';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';

import '../styles.scss';

export const SetNewLogin = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { email },
        errors,
    } = useAppSelector((state) => state.recruiterAppSettings.changeLogin);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(settingsActions.setChangeLoginField({ id, value }));
    };

    const submitSetNewPasswordHandler = () => dispatch(settingsActions.changeLoginSubmit());

    return (
        <div className='change-login'>
            <Alert
                text={__t(
                    'Новая электронная почта будет использоваться для входа на сайт, а также видна работодателю для контакта с вами.',
                )}
                type='warn'
                icon='circle-exclamation-regular'
                className='change-login__alert'
            />
            <div className='change-login__form-item scroll-margin-for-fixed-header'>
                <p className='change-login__form-label'>{__t('Новая электронная почта')}</p>
                <Input
                    value={email}
                    placeholder={__t('Введите адрес почты')}
                    onChange={(value: string) => inputChangeHandler('email', value)}
                    errors={errors?.email}
                />
            </div>
            <Button className='change-login__button' onClick={submitSetNewPasswordHandler}>
                {__t('Сохранить')}
            </Button>
        </div>
    );
};
